var map = {
	"./app.js": 688,
	"./discord.js": 2759,
	"./error.js": 6081,
	"./gather.js": 2446,
	"./index.js": 3419,
	"./language.js": 7797,
	"./map.js": 4553,
	"./match.js": 9514,
	"./notification.js": 1484,
	"./page.js": 2299,
	"./staff.js": 9345,
	"./steam.js": 6303,
	"./user.js": 6400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8043;